<template>
  <slot name="banner">
    <CommonBanner type="neutral">
      <template #tagline>
        <span v-html="$t`Выберите новый лимит </br> на покупки в рассрочку`" />
      </template>
    </CommonBanner>
  </slot>
  <RadioButtons
    v-model="selectedLimit"
    class="limit-items"
    :items="limits"
    large
    bordered
    reversed
    :visibleCount="visibleItemsCount"
  >
    <template #expander="{ expand, isHidden }">
      <LinkButton
        :text="isHidden ? $t`Показать все лимиты` : $t`Скрыть все лимиты`"
        :height="56"
        @click="onListExpandToggle(expand, isHidden)"
      >
        <template #tail>
          <span></span>
        </template>
      </LinkButton>
    </template>
  </RadioButtons>
  <CommonButton spaced @click="onLimitSelect">
    <slot name="btn-text"> </slot>
  </CommonButton>
</template>

<script>
import { ref, watch } from "vue";
import CommonBanner from "@/components/shared/banner/CommonBanner.vue";
import CommonButton from "@/components/shared/button/CommonButton.vue";
import RadioButtons from "@/components/shared/radio/RadioButtons.vue";
import LinkButton from "@/components/shared/button/LinkButton.vue";

export default {
  props: {
    /**
     * @type {import('vue').PropType<Array<string|number>>}
     */
    limits: {
      type: Array,
      required: true,
    },
  },
  components: {
    CommonBanner,
    CommonButton,
    RadioButtons,
    LinkButton,
  },
  emits: ["limit-selected", "limit-switch", "limit-expand"],
  setup(props, { emit }) {
    const visibleItemsCount = 4;
    const selectedLimit = ref(0);

    function onLimitSelect() {
      emit("limit-selected", selectedLimit.value);
    }

    function onLimitSwitch(val) {
      emit("limit-switch", val);
    }

    function onListExpandToggle(expand, isHidden) {
      emit("limit-expand", isHidden);
      expand();
    }

    watch(() => selectedLimit.value, onLimitSwitch);

    return {
      visibleItemsCount,
      selectedLimit,
      onLimitSelect,
      onListExpandToggle,
    };
  },
};
</script>

<style lang="scss" scoped>
.limit-items {
  padding: 0 15px 15px;
}

.link-btn {
  margin-bottom: -15px;
}

.spacer {
  height: 15px;
  background-color: #fff;
}
</style>
